import { Component } from '@angular/core';

@Component({
    selector: 'app-registration-dash-icon',
    standalone: true,
    imports: [],
    templateUrl: './registration-dash-icon.component.html',
})
export class RegistrationDashIconComponent {}
